module.exports = __webpack_public_path__ + "img/grading_button.445607e6.png";